<template>
  <div class="vx-row">

    <div class="vx-col w-full">
      <vx-card :title="'CURRENCY LIST'">

        <div id="notification-list-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="currencies">
              <template slot="thead">
                <vs-th width="25%">CODE</vs-th>
                <vs-th width="25%">NAME</vs-th>
                <vs-th width="25%">FX VALUE</vs-th>
                <vs-th width="25%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickUpdate(tr)" class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].code">
                    {{ data[indextr].code }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].fx_value">
                    {{ data[indextr].fx_value }}
                  </vs-td>

                  <vs-td>
                    <div class="justify-start vx-row">
                      <vx-tooltip v-if="data[indextr].code !== 'GBP'" text="View/Update" position="top">
                        <vs-button @click.stop="onClickUpdate(data[indextr])"  class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Forex Rate Logs" position="top">
                        <vs-button @click.stop="onClickViewLog(data[indextr])"  class="ml-3"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>

          </div>
        </div>

<!--        <gmap-autocomplete @place_changed="setPlace" class="introInput" >-->
<!--          <template v-slot:input="slotProps">-->
<!--            <vs-input class="w-full" size="small" ref="input"-->
<!--                      v-on:listeners="slotProps.listeners"-->
<!--                      v-on:attrs="slotProps.attrs" />-->
<!--          </template>-->
<!--        </gmap-autocomplete>-->

<!--        <pre>-->
<!--          ADDRESS 1: {{address1}}-->
<!--          ADDRESS 2: - -->
<!--          ADDRESS 3: - -->
<!--          CITY: {{locality}}-->
<!--          STATE/PROVINCE: {{administrative_area_level_1}}-->
<!--          POSTAL CODE: {{postcode}}-->
<!--          COUNTRY: {{country}}-->
<!--        </pre>-->


      </vx-card>
    </div>
    <update-currency-pop-up ref="updateCurrencyPopUp"/>
    <currency-adjust-log-pop-up ref="currencyAdjustLogPopUp"/>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import UpdateCurrencyPopUp from "@/components/popups/settings/currency/UpdateCurrencyPopUp";
  import CurrencyAdjustLogPopUp from "@/components/popups/settings/currency/CurrencyAdjustLogPopUp";


  const StaffRepository = RepositoryFactory.get('staff');
  export default {
    name: "CurrencySettings",
    data() {
      return {
        currencies: [],
        place: {address_components: ''},
        center: { lat: 10.0, lng: 10.0 },
        markers: [
          { position: { lat: 10.0, lng: 10.0 } },
          { position: { lat: 11.0, lng: 11.0 } },
        ],
        address1: '',
        postcode: '',
        locality: '',
        administrative_area_level_1: '',
        country: ''
      }
    },
    components: {
      UpdateCurrencyPopUp,
      CurrencyAdjustLogPopUp,
    },
    methods: {
      setPlace(place) {
        this.place = place
        for (const component of this.place.address_components) {
          const componentType = component.types[0];

          switch (componentType) {
            case "street_number": {
              this.address1 = `${component.long_name} ${this.address1}`;
              break;
            }

            case "route": {
              this.address1 += component.short_name;
              break;
            }

            case "postal_code": {
              this.postcode = `${component.long_name}${this.postcode}`;
              break;
            }

            case "postal_code_suffix": {
              this.postcode = `${this.postcode}-${component.long_name}`;
              break;
            }
            case "locality":
              this.locality = component.long_name;
              break;

            case "administrative_area_level_1": {
              this.administrative_area_level_1 = component.short_name;
              break;
            }
            case "country":
              this.country = component.long_name;
              break;
          }
        }
      },
      usePlace() {

      },
      async refreshData() {
        await this.fetchCurrencies()
      },
      async fetchCurrencies() {
        this.$vs.loading()
        const {data} =  (await StaffRepository.getCurrencyList()).data
        this.currencies = data
        this.$vs.loading.close()
      },
      onClickUpdate(tr) {
        this.$refs.updateCurrencyPopUp.openPopup(tr)
      },
      onClickViewLog(tr) {
        this.$refs.currencyAdjustLogPopUp.openPopup(tr.id, tr.code)
      }
    },
    async mounted() {
      await this.fetchCurrencies()
    }
  }
</script>

<style scoped>

</style>
